import lottie from 'lottie-web';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  async preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
    await loadFonts();
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.assetsLoad();
    this.load.start();

    this.load.on(
      'progress',
      () => {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      () => {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    // Plugins
    this.load.plugin(
      'rexkawaseblurpipelineplugin',
      'assets/rexkawaseblurpipelineplugin.min.js',
      true,
    );

    // Audio
    this.load.audio('hintaudio', 'assets/audio/Hint Alert.mp3');
    this.load.audio('incorrectaudio', 'assets/audio/Tire Screetch.mp3');
    this.load.audio('correctaudio', 'assets/audio/Success.wav');
    this.load.audio('yayaudio', 'assets/audio/confetti.wav');
    this.load.audio('lanechange', 'assets/audio/Lane Change New.mp3');
    this.load.audio('bgaudio', 'assets/audio/Race BG.mp3');
    this.load.audio('caraudio', 'assets/audio/Driving 1.mp3');
    this.load.audio('carRunning', 'assets/audio/Driving Continous.mp3');
    this.load.audio('ta1', 'assets/audio/ta1.mp3');
    this.load.audio('ta2', 'assets/audio/ta2.mp3');
    this.load.audio('rewardSound', 'assets/audio/reward reveal.mp3');

    // Start scene
    this.load.image('bg', 'assets/StartSceneAssets/bg.png');
    this.load.image('play_button', 'assets/StartSceneAssets/play_button.png');
    this.load.image('play_button_on', 'assets/StartSceneAssets/play_button_on.png');
    this.load.multiatlas(
      'carGo',
      'assets/StartSceneAssets/carGoAnim.json',
      'assets/StartSceneAssets',
    );
    this.load.multiatlas(
      'carOn',
      'assets/StartSceneAssets/carOnAnim.json',
      'assets/StartSceneAssets',
    );

    // Game scene images
    this.load.image('hintIcon', 'assets/GameSceneAssets/Hint.png');
    this.load.image('hint_1', 'assets/GameSceneAssets/hint-1hdpi.png');
    this.load.image('hint_2', 'assets/GameSceneAssets/hint-2hdpi.png');
    this.load.image('hint_3', 'assets/GameSceneAssets/hint-3.png');
    this.load.image('hint_4', 'assets/GameSceneAssets/hint-4.png');
    this.load.image('hint_5', 'assets/GameSceneAssets/hint-5.png');
    this.load.image('hint_6', 'assets/GameSceneAssets/hint-6.png');
    this.load.image('hint_7', 'assets/GameSceneAssets/hint-7.png');
    this.load.image('hint_8', 'assets/GameSceneAssets/hint-8.png');
    this.load.image('closeHint', 'assets/GameSceneAssets/closeHintIconhdpi.png');
    this.load.image('Car', 'assets/GameSceneAssets/Car.png');
    this.load.image('equal', 'assets/GameSceneAssets/equal.png');
    this.load.image('greater', 'assets/GameSceneAssets/greater.png');
    this.load.image('left arrow', 'assets/GameSceneAssets/left arrow.png');
    this.load.image('left strip', 'assets/GameSceneAssets/left strip.png');
    this.load.image('lesser', 'assets/GameSceneAssets/lesser.png');
    this.load.image('right arrow', 'assets/GameSceneAssets/right arrow.png');
    this.load.image('right strip', 'assets/GameSceneAssets/right strip.png');
    this.load.image('tree', 'assets/GameSceneAssets/tree.png');
    this.load.image('overlay', 'assets/GameSceneAssets/overlay.png');
    this.load.image('panel', 'assets/GameSceneAssets/panel.png');
    this.load.image('sky', 'assets/GameSceneAssets/sky.png');
    this.load.image('finish', 'assets/GameSceneAssets/Finish.png');
    this.load.image('green', 'assets/GameSceneAssets/green.png');
    this.load.image('bush', 'assets/GameSceneAssets/bush.png');
    this.load.image('rock', 'assets/GameSceneAssets/rock.png');
    this.load.image('text', 'assets/GameSceneAssets/text-1.png');
    this.load.image('text_2', 'assets/GameSceneAssets/text-2.png');
    this.load.image('progressBar', 'assets/GameSceneAssets/progressBar.png');
    this.load.image('greenEqual', 'assets/GameSceneAssets/greenEqual.png');
    this.load.image('greenGreater', 'assets/GameSceneAssets/greenGreater.png');
    this.load.image('greenLesser', 'assets/GameSceneAssets/greenLesser.png');
    // GameScene's `bg` is a separate image at GameSceneAssets/bg.png; loaded
    // here will overwrite the StartScene bg key — match source behaviour.
    this.load.image('bg', 'assets/GameSceneAssets/bg.png');
    for (let i = 1; i < 11; i++) {
      this.load.image('QL' + i, 'assets/GameSceneAssets/QL' + i + '.png');
      this.load.image('QR' + i, 'assets/GameSceneAssets/QR' + i + '.png');
    }

    // Game scene animations
    this.load.multiatlas(
      'carLeftTurn',
      'assets/GameSceneAssets/carLeftTurnAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'carRightTurn',
      'assets/GameSceneAssets/carRightTurnAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'carRightCorrect',
      'assets/GameSceneAssets/carRightCorrectAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'carCenterCorrect',
      'assets/GameSceneAssets/carCenterCorrectAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'carLeftCorrect',
      'assets/GameSceneAssets/carLeftCorrectAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'optionHitCorrect',
      'assets/GameSceneAssets/optionHitCorrectAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'optionHitWrong',
      'assets/GameSceneAssets/optionHitWrongAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'carLeftWrong',
      'assets/GameSceneAssets/carLeftWrongAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'carRightWrong',
      'assets/GameSceneAssets/carRightWrongAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'carCenterWrong',
      'assets/GameSceneAssets/carCenterWrongAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'hintFinalAnim',
      'assets/GameSceneAssets/hintFinalAnim.json',
      'assets/GameSceneAssets',
    );

    // End scene
    this.load.multiatlas(
      'endConfetti',
      'assets/EndSceneAssets/confetti/confettiAnimNew.json',
      'assets/EndSceneAssets/confetti',
    );
    this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
    this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
    this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
    this.load.image('retryButton', 'assets/EndSceneAssets/Retry Button.png');
    this.load.image('nextButton', 'assets/EndSceneAssets/nextButton.png');
    this.load.image('endScreenOverlay', 'assets/EndSceneAssets/endScreenOverlay.png');
    this.load.image('okayButton', 'assets/EndSceneAssets/okaybutton.png');
    this.load.image('rewardEarned', 'assets/EndSceneAssets/Rewards earned!.png');
    this.load.image('rewardName', 'assets/EndSceneAssets/Trophy.png');
    this.load.image('retry_button_on', 'assets/EndSceneAssets/retry_button_on.png');
    this.load.image('next_button_on', 'assets/EndSceneAssets/next_button_on.png');
    this.load.image('okay_button_on', 'assets/EndSceneAssets/okay_button_on.png');
    this.load.image('okayDisabled', 'assets/EndSceneAssets/okayDisabled.png');
    this.load.image('youWon', 'assets/EndSceneAssets/You won.png');

    // Reward animations & spotlight atlases
    for (let i = 1; i <= 5; i++) {
      this.load.atlas(
        'rewardAnim_' + i,
        'assets/reward anim new/rewardAnim-' + i + '-0.png',
        'assets/reward anim new/rewardAnim-' + i + '.json',
      );
    }
    for (let i = 1; i <= 6; i++) {
      this.load.atlas(
        'spotlight_' + i,
        'assets/Spotlight New/SpotlightAnim-' + i + '-0.png',
        'assets/Spotlight New/SpotlightAnim-' + i + '.json',
      );
    }
  }
}
